/* eslint-disable class-methods-use-this */
import React from 'react';
import store from 'Store';
import BCC from 'utils/BCC';
import watch from 'redux-watch';
import { Grid } from 'components/ui';
import Location from 'utils/Location';
import FrameworkUtils from 'utils/framework';
import BaseClass from 'components/BaseClass/BaseClass';
import SampleItem from 'components/Product/SampleItem/SampleItem';
import NoSamplesMessage from 'components/Content/FreeSamples/NoSamplesMessage';

const { IMAGE_SIZES } = BCC;
const { wrapComponent } = FrameworkUtils;

class Samples extends BaseClass {
    state = {
        samplesList: null,
        allowedQtyPerOrder: 0
    };

    componentDidMount() {
        const samplesObj = store.getState().samples;
        const watchSamples = watch(store.getState, 'samples');
        const isReplacementOrder = Location.isReplacementOrderPage();

        if (samplesObj) {
            this.setState({
                samplesList: samplesObj.samples,
                allowedQtyPerOrder: isReplacementOrder ? this.props.allowedQtyPerOrder : samplesObj.allowedQtyPerOrder,
                isReplacementOrder: isReplacementOrder
            });
        }

        store.subscribe(
            watchSamples(newSamples => {
                this.setState({
                    samplesList: newSamples.samples || newSamples,
                    allowedQtyPerOrder: newSamples.allowedQtyPerOrder
                });
            }),
            this
        );
    }

    render() {
        const isMobile = Sephora.isMobile();
        const { analyticsContext } = this.props;
        const itemSpacing = isMobile ? 7 : 5;
        const samples = this.state.samplesList;
        const numSamplesPerRow = isMobile ? 2 : 6;

        if (Array.isArray(samples) && samples.length === 0) {
            return <NoSamplesMessage />;
        }

        return (
            <Grid
                columns={numSamplesPerRow}
                gap={isMobile ? 5 : 3}
                rowGap={itemSpacing}
            >
                {samples &&
                    samples.map(sample => (
                        //revisit This
                        <SampleItem
                            key={sample.skuId}
                            imageSize={isMobile ? IMAGE_SIZES[162] : IMAGE_SIZES[97]}
                            imagePath={sample.gridImage}
                            maxSampleQty={this.state.allowedQtyPerOrder}
                            isReplacementOrder={this.state.isReplacementOrder}
                            type={'sample'}
                            isToolTipEnabled={true}
                            buttonSize='sm'
                            analyticsContext={analyticsContext}
                            {...sample}
                        />
                    ))}
            </Grid>
        );
    }
}

export default wrapComponent(Samples, 'Samples');
